import 'core-js/stable';
import 'regenerator-runtime/runtime';
import Vue from 'vue';
// import './plugins/axios';
import vuetify from './plugins/vuetify';
import App from './App.vue';
import router from './router';
import store from '@/store/index';
import './registerServiceWorker';
import dateFilter from '@/filters/date.filter';
import axios from 'axios';

Vue.config.productionTip = false;
Vue.filter('date', dateFilter);

axios.defaults.baseURL = '/api/';
router.beforeEach((to, from, next) => {
    if(to.meta.requiresAuth) {
        if(store.state.user.authenticated) {
            return next();
        }
        else {
            return next({name: 'login'});
        }
    }
    if(to.meta.requiresGuest) {
        if(store.state.user.authenticated) {
            return next({name: 'dashboard'});
        }
        else {
            return next();
        }
    }
});

new Vue({
  vuetify,
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
